export const netAssetValue = () => {
    const select = document.getElementById('historical-class-select');
    const tbody = document.getElementById('historical-nav-data');
    const classHeader = document.getElementById('class-header');

    if (select && tbody) {
        select.addEventListener('change', function() {
            const selectedClass = this.value;
            
            // Show loading state
            tbody.innerHTML = '<tr><td colspan="13" style="text-align: center;">Loading...</td></tr>';
            
            // Make AJAX request
            const formData = new FormData();
            formData.append('action', 'tpg_get_historical_nav');
            formData.append('nonce', localized_object.nonce);
            formData.append('class', selectedClass);

            fetch(localized_object.ajax_url, {
                method: 'POST',
                credentials: 'same-origin',
                body: formData
            })
            .then(response => response.json())
            .then(data => {
                if (data.success && data.data) {
                    // Update class header
                    classHeader.textContent = data.data.class;
                    
                    // Clear and rebuild table
                    tbody.innerHTML = '';
                    const years = Object.keys(data.data.data).sort((a, b) => b - a); // Sort years descending
                    
                    years.forEach(year => {
                        const months = data.data.data[year];
                        const row = document.createElement('tr');
                        
                        // Add year cell
                        const yearCell = document.createElement('td');
                        yearCell.setAttribute('data-label', 'Year');
                        yearCell.textContent = year;
                        row.appendChild(yearCell);
                        
                        // Add month cells
                        ['jan', 'feb', 'mar', 'apr', 'may', 'jun', 'jul', 'aug', 'sep', 'oct', 'nov', 'dec'].forEach(month => {
                            const cell = document.createElement('td');
                            cell.setAttribute('data-label', month);
                            cell.textContent = months[month] ? months[month] : '—';
                            row.appendChild(cell);
                        });
                        
                        tbody.appendChild(row);
                    });
                } else {
                    tbody.innerHTML = '<tr><td colspan="13" style="text-align: center;">No data available</td></tr>';
                }
            })
            .catch(error => {
                console.error('Error:', error);
                tbody.innerHTML = '<tr><td colspan="13" style="text-align: center;">Error loading data</td></tr>';
            });
        });
    }
}